import { callBizpart } from '../../../../../Js/React/Services/common';
import { ResponseStatus } from '../../../../../FrontEndReact/src/Core/Types/base';
import { User } from '../../../../../FrontEndReact/src/Core/Types/user';

const apiPath = 'api/laxhjalpenregistration/';

export type LaxhjalpenHomeworkHelper = {
	Id: number;
	Name: string;
	Email: string;
	UnitIds: number[];
	IsActive: boolean;
	IsDeleted: boolean;
};

export type LaxhjalpenGuardianRegistration = {
	email: string;
	firstName: string;
	lastName: string;
	mobile?: string;
};

export type LaxhjalpenStudentRegistrationRequest = {
	ssn?: string;
	email: string;
	firstName: string;
	lastName: string;
	unitId: number;
	homeworkHelperUserId?: number | null;
	guardians: LaxhjalpenGuardianRegistration[];
};

export type LaxhjalpenStudentRegistrationResponse = ResponseStatus & {
	StudentUserId?: number;
	GuardianUserIds?: number[];
	ReusedGuardianUserIds?: number[];
};

export type LaxhjalpenHomeworkHelperStudentLinkRequest = {
	unitId: number;
	studentUserId: number;
	homeworkHelperUserId: number;
};

export async function getHomeworkHelpers(unitId: number) {
	const path = `${apiPath}GetHomeworkHelpers?unitId=${unitId}`;
	return normalizeArrayResponse<LaxhjalpenHomeworkHelper>(await callBizpart<unknown>(path));
}

export async function getAllowedStudentRegistrationUnitTypeIds() {
	const path = `${apiPath}GetAllowedStudentRegistrationUnitTypeIds`;
	return normalizeArrayResponse<number>(await callBizpart<unknown>(path));
}

export async function getStudents(unitId: number) {
	const path = `${apiPath}GetStudents?unitId=${unitId}`;
	return normalizeArrayResponse<User>(await callBizpart<unknown>(path));
}

export async function registerStudent(request: LaxhjalpenStudentRegistrationRequest) {
	const path = `${apiPath}RegisterStudent`;
	return await callBizpart<LaxhjalpenStudentRegistrationResponse>(path, request, 'POST');
}

export async function saveHomeworkHelperStudentLink(request: LaxhjalpenHomeworkHelperStudentLinkRequest) {
	const path = `${apiPath}SaveHomeworkHelperStudentLink`;
	return await callBizpart<ResponseStatus>(path, request, 'POST');
}

function normalizeArrayResponse<T>(response: unknown): T[] {
	if (Array.isArray(response)) {
		return response as T[];
	}

	if (response && typeof response === 'object') {
		const objectResponse = response as Record<string, unknown>;
		const nestedArray =
			objectResponse.$values ||
			objectResponse.Values ||
			objectResponse.Items ||
			objectResponse.Result ||
			objectResponse.Users;

		if (Array.isArray(nestedArray)) {
			return nestedArray as T[];
		}
	}

	return [];
}
